<mat-card class="bg-white mat-elevation-z3">
    <mat-card-header>
        <mat-card-title>
            <mat-icon class="mx-1" color="primary">directions_car</mat-icon>
            {{ isArchive === '1' ? 'Archiwum samochodów' : 'Samochody' }}
        </mat-card-title>
        <mat-card-subtitle>
            {{ isArchive === '1' ? 'Sprawdź archiwalne samochody' : 'Dodaj, sprawdź lub edytuj samochód.' }}
        </mat-card-subtitle>
        <div class="mx-3" *ngIf="authService.user.type === 'admin' && isArchive !== '1'">
            <button mat-fab color="warn" matTooltip="Dodaj samochód" (click)="addCar()"
                    matTooltipPosition="right" aria-label="Dodaj samochód">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="pt-4">
            <mat-form-field appearance="outline" style="width: 75%">
                <mat-label>Samochód ...</mat-label>
                <input type="text" matInput placeholder="Samochód..."
                       (keyup)="setSearchFilter()" [(ngModel)]="searchFilter">
                <mat-icon matSuffix color="primary">search</mat-icon>
            </mat-form-field>
        </div>
        <div class="table-container pt-2 pb-4">
            <table mat-table [dataSource]="cars$" matSort (matSortChange)="sortData($event)"
                   matSortActive="inspection_date" matSortDisableClear matSortDirection="asc">

                <!-- inspection_date column -->
                <ng-container matColumnDef="inspection_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="inspection_date">Przegląd</th>
                    <td mat-cell *matCellDef="let car">{{ car.inspection_date  | date: 'dd/MM/yyyy' }}</td>
                </ng-container>

                <!-- insurance_end_date column -->
                <ng-container matColumnDef="insurance_end_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="insurance_end_date">Ubezpieczenie</th>
                    <td mat-cell *matCellDef="let car">{{ car.insurance_end_date | date: 'dd/MM/yyyy' }}</td>
                </ng-container>

                <!-- registration_number column -->
                <ng-container matColumnDef="registration_number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="registration_number">Rejestracja</th>
                    <td mat-cell *matCellDef="let car">{{ car.registration_number }}</td>
                </ng-container>

                <!-- car_brand column -->
                <ng-container matColumnDef="car_brand">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="car_brand">Marka</th>
                    <td mat-cell *matCellDef="let car">{{ car.car_brand }}</td>
                </ng-container>

                <!-- actions column -->
                <ng-container matColumnDef="actions">
                    <th class="table-cell-width" mat-header-cell *matHeaderCellDef>akcje</th>
                    <td mat-cell *matCellDef="let car">
                        <div class="d-flex">
                            <button mat-mini-fab color="indigo" matTooltip="Pokaż"
                                    (click)="showCar(car.id)"
                                    matTooltipPosition="right" aria-label="Pokaż">
                                <mat-icon>remove_red_eye</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator class="bg-white" [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)">
        </mat-paginator>
        <ng-container *ngIf="!cars$.data.length">
            <div class="text-center py-5">
                <p>Brak samochodów.</p>
            </div>
        </ng-container>
        <div class="mt-3" *ngIf="isLoading">
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading" color="primary"></mat-progress-bar>
        </div>
    </mat-card-content>
</mat-card>
